module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-crop"
  }, [_vm._l((_vm.imageArray), function(image) {
    return (_vm.svgFilter) ? _c('svg', {
      staticClass: "element",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      },
      on: {
        "load": _vm.removeOldElement
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": image.src,
        "width": "100%",
        "height": "100%",
        "preserveAspectRatio": "xMidYMid slice"
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.imageArray), function(image) {
    return (!_vm.svgFilter) ? _c('img', {
      staticClass: "element",
      style: (image.styling),
      attrs: {
        "src": image.src,
        "alt": _vm.alt
      },
      on: {
        "load": _vm.removeOldElement
      }
    }) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-1e1cc228"}!./scripts/sky-crop/sky-crop.html
// module id = 343
// module chunks = 1